<template>
  <div class="curation-subpage-list">
    <h2 class="jps-section-title">{{ lss('目次', 'Index') }}</h2>
    <ul>
      <li v-for="n in pageLength" :key="n">
        <CurationMediaBlock :curation="curation" :page="n" />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
const { lss } = useI18n()

interface Props {
  def: PartSubPageList
  curation: Curation
}
const props = withDefaults(defineProps<Props>(), {})

const pageLength = computed(() => {
  if (props.curation && props.curation.subPages)
    return props.curation.subPages.length
  return 0
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.curation-subpage-list {
  @include base-content-width();
  padding-top: 1rem;
  padding-bottom: 1rem;
  ul {
    border: 1px solid $jps-gray-200;
    border-radius: $global-radius;
    overflow: hidden;
    @include panel-shadow();
    li {
      padding: 0rem;
      border-bottom: 1px solid $jps-gray-200;
      &:last-child {
        border-bottom: none;
      }
      &:hover {
        background: $jps-gray-100;
      }
    }
  }
  .router-link-exact-active {
    article {
      background: $jps-gray-300;
    }
  }
}
</style>
